module.exports = __webpack_public_path__ + "media/images/features/3/studio-2-6475bd157a658a3e49ba77b4228f7852.jpg";